export enum LIMIT_FREE {
    FORMS = 1,
    SAVED_BLOCKS_MEMORY = 100,
    BLOCKS = 10,
    NAV_ITEM = 5,
    SUBPAGES = 1,
    PUBLISHED_PAGE = 5,
    TEMPLATES = 5
}